/**
 * Seed categories for a Nicaraguan pulpería.
 *
 * Suggestions, not a fixed list: a product's category is free text, so nobody is blocked at
 * data entry because the shelf they are looking at is not in an enum someone wrote first.
 */
export const CATEGORIAS_SUGERIDAS: readonly string[] = [
  'Granos básicos',
  'Abarrotes',
  'Bebidas',
  'Lácteos',
  'Carnes y embutidos',
  'Frutas y verduras',
  'Panadería',
  'Golosinas',
  'Limpieza',
  'Higiene personal',
  'Medicamentos',
  'Ferretería',
  'Mayoreo',
  'Otros',
];
